let talks: talk[]  = [  
    // {
    //     date: new Date(2025, 6, 9),
    //     title: "Effective homology and computation of periods via Picard—Lefschetz theory",
    //     url: "https://meetings.siam.org/sess/dsp_programsess.cfm?SESSIONCODE=84142",
    //     location: "SIAM AG25 — Madison, Wisconsin",
    //     location_url: "https://www.siam.org/conferences/cm/conference/ag25",
    //     img_url: new URL("./../imgs/siamag25.png", import.meta.url).toString(),
    //     abstract: ""
    // },
    // {
    //     date: new Date(2026, 3, 20),
    //     title: "TBA",
    //     url: "",
    //     location: "Loops and Geometry workshop, YoungSt@rs -  Erwin Schrödinger Institute, Vienna",
    //     location_url: "",
    //     img_url: new URL("./../imgs/ESI.png", import.meta.url).toString(),
    //     abstract: ""
    // },  
    {
        date: new Date(2026, 5, 3),
        title: "Numerical computations of periods and monodromy representations",
        url: "",
        location: "ECR event — Durham University",
        location_url: "",
        img_url: new URL("./../imgs/durham.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2026, 3, 20),
        title: "Numerical computations of periods",
        url: "https://indico.mitp.uni-mainz.de/event/467/",
        location: "Loops & Geometry: Hidden Structures in Multi-loop Amplitudes — Youngst@rs",
        location_url: "https://indico.mitp.uni-mainz.de/event/467/page/950-speaker-list",
        img_url: new URL("./../imgs/youngst@rs.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2026, 2, 25),
        title: "Numerical computations of periods",
        url: "https://www.esi.ac.at/events/e586/",
        location: "Mathematical structures of amplitudes workshop — Erwin Schrödinger Institute, Vienna",
        location_url: "https://www.esi.ac.at/events/e586/",
        img_url: new URL("./../imgs/ESI.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2026, 2, 2),
        title: "Monodromy of Symmetric Cubic Surfaces",
        url: "https://conferences.cirm-math.fr/3559.html",
        location: "Journées Nationales du Calcul Formel (JNCF) 2026 — Marseille Luminy",
        location_url: "https://www.cirm-math.fr/Schedule/display.php?id_renc=3559",
        img_url: new URL("./../imgs/jncf2.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2026, 0, 28),
        title: "Numerical computations of periods and monodromy representations",
        url: "https://seedseminar.apps.math.cnrs.fr/",
        location: "Seed Seminar — Institut Henri Poincaré, Paris",
        location_url: "https://seedseminar.apps.math.cnrs.fr/",
        img_url: new URL("./../imgs/SEED.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2025, 8, 25),
        title: "Canonical form of differential systems of displaced hyperplane arrangements from positive geometry",
        url: "https://indico.mitp.uni-mainz.de/event/413/timetable/#20250925.detailed",
        location: "MathemAmplitudes — MITP, Mainz",
        location_url: "https://indico.mitp.uni-mainz.de/event/413/",
        img_url: new URL("./../imgs/mathemamplitudes.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2025, 8, 5),
        title: "Periods of Hadamard products of elliptic surfaces and the Gamma conjecture",
        url: "https://indico.hiskp.uni-bonn.de/event/833/timetable/#20250905",
        location: "Elliptics and Beyond 2025 — Bethe Center for Theoretical Physics, Bonn",
        location_url: "https://indico.hiskp.uni-bonn.de/event/833/",
        img_url: new URL("./../imgs/BCTP.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2025, 5, 6),
        title: "Computing periods and volumes of semialgebraic sets",
        url: "https://plan.events.mpg.de/event/473/program",
        location: "2nd MPI (Dresden+Leipzig) Day — Max Planck Institute of Molecular Cell Biology and Genetics, Dresden",
        location_url: "https://plan.events.mpg.de/event/473/",
        img_url: new URL("./../imgs/MPI_MCBG.png", import.meta.url).toString(),
        abstract: ""
    },  
    {
        date: new Date(2025, 4, 28),
        title: "Periods of Hadamard products of elliptic surfaces and the Gamma conjecture",
        url: "https://smagp.pages.math.cnrs.fr/AGISAF2025/index.html",
        location: "Algebraic geometry, integrable systems and automorphic forms — Lille",
        location_url: "https://fmhf.math.cnrs.fr/blog/2025_algebraic_geometry_integrable_systems_and_automorphic_forms/",
        img_url: new URL("./../imgs/lille_AGintegrableautomorphic.png", import.meta.url).toString(),
        abstract: ""
    },    
    {
        date: new Date(2025, 2, 28),
        title: "Some monodromy computations in dimensions 0,1,2,3",
        url: "https://indico.mitp.uni-mainz.de/event/397/timetable/#20250327",
        location: "The Arithmetic of Calabi—Yau Manifolds — MITP, Mainz",
        location_url: "https://indico.mitp.uni-mainz.de/event/397/",
        img_url: new URL("./../imgs/arithmeticCYM.png", import.meta.url).toString(),
        abstract: ""
    }, 
    {
        date: new Date(2025, 1, 18),
        title: "Effective homology and numerical integration of periods",
        url: "https://canari.inria.fr/seminar/current.html",
        location: "CANARI team seminar —  Institut de Mathématiques de Bordeaux, Bordeaux",
        location_url: "https://canari.inria.fr/seminar/current.html",
        img_url: new URL("./../imgs/canari.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2025, 0, 14),
        title: "Effective homology and numerical integration of periods",
        url: "https://jovenes2025.rsme.es/paralelaAL08.html",
        location: "Numerical Algebraic Geometry — RSME's 7th Congress of Young Researchers, Bilbao",
        location_url: "https://jovenes2025.rsme.es/index_en.html",
        img_url: new URL("./../imgs/bilbao.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 11, 17),
        title: "Some computations related to monodromy representations",
        url: "https://mathexp.eu/seminar/",
        location: "MathExp Seminar — Inria Saclay, Palaiseau",
        location_url: "https://mathexp.eu/seminar/",
        img_url: new URL("./../imgs/mathexp.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 10, 12),
        title: "Numerical integration of periods and monodromy representations",
        url: "https://www.mis.mpg.de/events/series/positive-geometry-seminar",
        location: "Positive geometry seminar — Max Planck Institute for Mathematics in the Sciences, Leipzig",
        location_url: "https://www.mis.mpg.de/events/event/to-be-announced-f0039781",
        img_url: new URL("./../imgs/mpimis.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 9, 14),
        title: "Effective homology and periods of algebraic varieties",
        url: "https://indico.mpp.mpg.de/event/10191/",
        location: "Holonomic Techniques for Feynman Integrals — Max Planck Institute for Physics, Garching",
        location_url: "https://indico.mpp.mpg.de/event/10191/contributions/38054/",
        img_url: new URL("./../imgs/munich.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 4, 9),
        title: "Periods of hypersurfaces via effective homology",
        url: "https://cmsa.fas.harvard.edu/event/agst-5924/",
        location: "Algebraic Geometry in String Theory Seminar - CMSA, Harvard University",
        location_url: "https://cmsa.fas.harvard.edu/event/agst-5924/",
        img_url: new URL("./../imgs/cmsa.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 3, 29),
        title: "Periods of hypersurfaces via effective homology",
        url: "https://www.uni-saarland.de/lehrstuhl/lazic/oberseminar-algebraische-geometrie.html",
        location: "Oberseminar Algebraische Geometrie — Saarbrücken University",
        location_url: "https://www.uni-saarland.de/lehrstuhl/lazic/oberseminar-algebraische-geometrie.html",
        img_url: new URL("./../imgs/saarbrucken.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2024, 2, 8),
        title: "Topology and periods of elliptic surfaces",
        url: "https://conferences.cirm-math.fr/3047.html",
        location: "Journées Nationales du Calcul Formel (JNCF) 2024 — Marseille Luminy",
        location_url: "https://www.cirm-math.fr/Schedule/display.php?id_renc=3047",
        img_url: new URL("./../imgs/jncf2.png", import.meta.url).toString(),
        abstract: ""
    },
    {
        date: new Date(2023, 10, 22),
        title: "Periods of hypersurfaces via effective homology",
        url: "https://www.ihes.fr/~vanhove/motivefeynman-2023.html",
        location: "Online seminar on motives and period integrals in Quantum field theory and String theory",
        location_url: "https://www.ihes.fr/~vanhove/motivefeynman.html#nexttalk",
        img_url: new URL("./../imgs/motivic_seminar_icon.png", import.meta.url).toString(),
        abstract: "The Tardigrade diagram is a Feynman diagram of which the geometry is a family of quartic K3 surfaces. Starting from the defining polynomial equation of that family, we can recover an explicit description of the entire cycle lattice of its generic K3 fiber and compute its periods. This description allows us to compute geometrical invariants of the K3 family. In particular, we recover an explicit embedding of the Picard lattice in the standard K3 lattice, keeping track of the different components of the special fibers of the elliptic fibration."
    },
    {
        date: new Date(2023, 10, 15),
        title: "Periods of hypersurfaces via effective homology",
        url: "https://indico.math.cnrs.fr/event/10817/",
        location: "Combinatorics and Arithmetic for Physics — IHES, Bures-sur-Yvette",
        location_url: "https://indico.math.cnrs.fr/event/10817/timetable/#29-periods-of-hypersurfaces-vi",
        img_url: new URL("./../imgs/CAP23.png", import.meta.url).toString(),
        abstract: "the period matrix of a smooth complex projective variety X encodes the isomorphism between the singular homology of X and its De Rham cohomology given by the De Rham theorem. Numerical approximations with sufficient precision of the entries of this matrix, called periods, allow to recover some algebraic invariants of the varieties, as shown for example by Torelli-type theorems. I will present a method relying on the computation of an effective description of the homology for obtaining such numerical approximations of the periods of hypersurfaces. This method is sufficiently efficient to allow computing the periods of dense quartic K3 surfaces in the three-dimensional projective space."
    },
    {
        date: new Date(2023, 8, 15),
        title: "Calcul de périodes d’hypersurfaces complexes projectives par théorie de Picard-Lefschetz",
        url: "https://math.univ-angers.fr/seminaires/seminaire-de-geometrie-algebrique/",
        location: "Séminaire de Géométrie Algébrique de l'Université d'Angers",
        location_url: "https://math.univ-angers.fr/seminaires/seminaire-de-geometrie-algebrique/",
        img_url: new URL("./../imgs/angers.png", import.meta.url).toString(),
        abstract: "Les périodes d’une variété algébrique encodent l’isomorphisme de De Rham entre sa cohomologie de De Rham algébrique et son homologie singulière. Leur approximation numérique fine (plusieurs centaines de chiffres significatifs) permet de retrouver certains invariants algébriques de la variété, comme par exemple le rang de Picard dans le cas des surfaces. Le but de cet exposé est de présenter un algorithme reposant sur une théorie de Picard-Lefschetz effective pour calculer ces périodes avec une telle précision."
    },
    {
        date: new Date(2023, 5, 11),
        title: "Numerical Computation of the Homology and Periods of Complex Surfaces",
        url: "https://meetings.siam.org/sess/dsp_programsess.cfm?SESSIONCODE=77913",
        location: "SIAM AG23 — Eindhoven",
        location_url: "https://www.siam.org/conferences/cm/conference/ag23",
        img_url: new URL("./../imgs/siamag_icon.png", import.meta.url).toString(),
        abstract: "The period matrix of a smooth complex projective algebraic variety encodes the duality between singular homology and DeRham cohomology given by the DeRham theorem. Its entries, called periods, are integrals of algebraic forms on homological cycles. This matrix carries information about fine algebraic invariants of the variety (as shown by Torelli-type theorems, for instance), and periods also arise in theoretical physics (Feynman integrals). We provide a direct method to efficiently compute numerical approximations of the period matrix of a complete intersection. More precisely, our method relies on an effective Picard-Lefschetz theory, from which we obtain an explicit description of the cycles that is well suited for numerical integration. This allows us to compute the holomorphic periods of generic quartic surfaces, which encodes the Hodge decomposition of the variety. This computation, which was previously unattainable, can be done an hour. In this lecture, I will give a description of this method. This is joint work with my advisors P. Lairez and P. Vanhove."
    },
    {
        date: new Date(2023, 2, 6),
        title: "Computing periods of hypersurfaces",
        url: "https://conferences.cirm-math.fr/2888.html",
        location_url:"https://www.cirm-math.fr/Schedule/display.php?id_renc=2888",
        location: "Journées Nationales du Calcul Formel (JNCF) 2023 — Marseille Luminy",
        img_url: new URL("./../imgs/jncf2.png", import.meta.url).toString(),
        abstract: "The period matrix encodes the isomorphism between homology and cohomology given by the DeRham theorem. In the case of hypersurfaces, its entries are integrals of rational fractions. The matrix carries information about the geometry of its variety, from which we can recover fine algebraic invariants. Earlier methods for computing numerical approximations of periods rely on integration of differential operators, and are obstructed by the size of the differential operators. This obstruction can be reduced by computing an explicit basis of homology which is adapted to the computation of the rational integrals. From this observation, I will describe an algorithm for efficiently computing this matrix. This work is in progress and joint with P. Lairez and P. Vanhove."
    },
    {
        date: new Date(2023, 1, 13),
        title: "The conditional theory of critical events: predicting number of merger per halo",
        url:"https://online.kitp.ucsb.edu/online/cosmicweb23/",
        location: "The Cosmic Web: Connecting Galaxies to Cosmology at High and Low Redshift, KITP UCSB",
        location_url:"https://www.kitp.ucsb.edu/activities/cosmicweb23",
        img_url: new URL("./../imgs/cosmicweb_icon.png", import.meta.url).toString(),
        abstract: "We quantify from first principles the number of major mergers a dark matter halo undergoes as a function of redshift. We rely on the Ansatz that this number can be predicted in the initial linear density field from the coalescence of critical points (peaks and saddle points) with increasing smoothing scale as a proxy for cosmic time. We recover from first principles that halos typically undergo 4 mergers, with a redshift dependence that is proportional to (1 + z) . We successfully validate this assumption with the notion of topological mergers. The investigation is first carried in 1D for simplicity and computational expediency, and then extended to 2 and 3D. This is joint work with Corentin Cadiou and Dmitri Pogosyan."
    },
    {
        date: new Date(2022, 8, 2),
        title: "Computing periods of hypersurfaces",
        url: "https://sites.google.com/view/computationalgeometry22/home",
        location_url: "https://sites.google.com/view/computationalgeometry22/home",
        img_url: new URL("./../imgs/nottingham_icon.png", import.meta.url).toString(),
        location: "Computational Geometry Workshop in Nottingham",
        abstract: "A period of a complex algebraic surface is the integral of a holomorphic 2-form on a homological 2-cycle. Such numbers carry important information about the geometry of the hypersurface (see for instance Torelli-type theorems), and arise in theoretical physics (Feynman integrals). We provide a direct method to efficiently carry out computations of numerical approximations of these periods. More precisely, our method relies on finding an explicit description – which stems from Picard-Lefschetz theory – of the 2-cycles in a way that is suitable for integration. In this talk, I will describe some elements of this method and give a demonstration of my code. This work is in progress and joint with my advisors P. Lairez and P. Vanhove."
    },
]

export default talks